import { render, staticRenderFns } from "./configuration-automation-personnel-algorithms-selection-form-element.vue?vue&type=template&id=274bde9f&scoped=true&"
import script from "./configuration-automation-personnel-algorithms-selection-form-element.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-algorithms-selection-form-element.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-algorithms-selection-form-element.scss?vue&type=style&index=0&id=274bde9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bde9f",
  null
  
)

export default component.exports